import React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentScript, setCodeEditor} from "store/actions/codeEditor";
import {changeProperty, selectObject} from "store/actions/asset";
import {ACTION_TYPE} from "utils";
import ScriptsContent from "./ScriptsContent";
import ScriptsContentPrevious from "./ScriptsContentPrevious";
import styles from "./index.module.scss";
import _ from "lodash";
import {TwoBtnPopUp, showPopUp} from "components/PopUp";

function ScriptTab() {
  const dispatch = useDispatch();
  const scenes = useSelector(state => state.asset.scenes);
  const action = useSelector(state => state.asset.action);
  const codeEditor = useSelector(state => state.codeEditor);
  const selectedKeys = useSelector(state => state.asset.selectedObjectKeys);
  const versionCompatibility = useSelector(state => state.version.versionCompatibility);
  const [scriptObjects, setScriptObjects] = useState([]);

  useEffect(() => {
    getScriptList();
  }, []);

  useEffect(() => {
    if (action.category === "script") {
      getScriptList();
    }
  }, [action]);

  const createAction = ({category, name, value}) => {
    return {
      command: ACTION_TYPE.CHANGE_PROPERTY,
      category,
      name,
      value,
    };
  };

  const addUserScript = type => {
    if (type === "serverScript") {
      dispatch(
        changeProperty(
          createAction({
            category: "script",
            name: "addServerScript",
          }),
        ),
      );
    } else if (type === "clientScript") {
      dispatch(
        changeProperty(
          createAction({
            category: "script",
            name: "addClientScript",
          }),
        ),
      );
    }
  };

  const removeUserScript = (type, title, index) => {
    showPopUp(
      <TwoBtnPopUp
        title={`Are you sure to remove the script? ${title}`}
        confirmBtn={"Confirm"}
        cancelBtn={"Cancel"}
        confirmAction={() => {
          if (type === "serverScript") {
            dispatch(
              changeProperty(
                createAction({
                  category: "script",
                  name: "removeServerScript",
                  value: index,
                }),
              ),
            );
          } else if (type === "clientScript") {
            dispatch(
              changeProperty(
                createAction({
                  category: "script",
                  name: "removeClientScript",
                  value: index,
                }),
              ),
            );
          }
          if (codeEditor.isOpen && codeEditor.currentScript.index === index && !codeEditor.showScriptList) {
            dispatch(setCodeEditor(false));
          }
        }}
      />,
      {
        defaultPadding: false,
        noBackground: true,
      },
    );
  };

  const getScriptList = () => {
    if (_.isEmpty(scenes)) return;

    const scriptObjects = [];
    scenes["default"].traverse(obj => {
      if (!obj.userData.objectScripts) return;
      if (obj.userData.objectScripts.serverScripts.length === 0 && obj.userData.objectScripts.clientScripts.length === 0) return;
      scriptObjects.push(obj);
    });
    scenes["GUI"].traverse(obj => {
      if (!obj.userData.objectScripts) return;
      if (obj.userData.objectScripts.serverScripts.length === 0 && obj.userData.objectScripts.clientScripts.length === 0) return;
      scriptObjects.push(obj);
    });
    setScriptObjects(scriptObjects);
  };

  const onClickScriptItem = (objUuid, type, index, title, source) => {
    if (versionCompatibility?.script.inObject) {
      dispatch(setCurrentScript({objUuid, type, index, title, source}));
      dispatch(setCodeEditor(false));
      setTimeout(() => {
        dispatch(setCodeEditor(true));
      }, 100);
    } else {
      const source = scenes["default"].userData.scriptJS;
      dispatch(setCurrentScript({objUuid: scenes["default"].uuid, type: "scriptJS", index: 0, title: "sceneScript", source: source}));
      return dispatch(setCodeEditor(!codeEditor.isOpen));
    }
  };

  if (_.isEmpty(scenes)) return null;

  return (
    <div className={styles.container}>
      <div className={styles.tab}>Script</div>
      <div className={styles.wrapper}>
        {versionCompatibility?.script.inObject ? (
          <ScriptsContent
            scriptedObjects={scriptObjects}
            selectedKeys={selectedKeys}
            selectObject={selectObject}
            onClickScriptItem={onClickScriptItem}
            addUserScript={addUserScript}
            removeUserScript={removeUserScript}
          />
        ) : (
          <ScriptsContentPrevious object={scenes["default"]} onClickScriptItem={onClickScriptItem} />
        )}
      </div>
    </div>
  );
}

export default ScriptTab;
